/**
 * Copyright (c) 2021-2026 Kognitos, Inc. All rights reserved.
 */

export const FEATURE_FLAGS = {
  ENABLE_NOTIFICATIONS_IN_UI: 'enable_notifications_in_ui',
  ENABLE_ONBOARDING_TOURS: 'enable_onboarding_tours',
  ENABLE_SUPPORT_ACCESS: 'enable_support_access',
  // Appliance-only (single-VM): break-glass remote access to the VM host itself.
  // Distinct from ENABLE_SUPPORT_ACCESS (app-level RBAC role grants). Enable this
  // gate for the appliance in Statsig.
  ENABLE_REMOTE_SUPPORT_ACCESS: 'enable_remote_support_access',
  ENABLE_CREDITS_CONSUMPTION_IN_UI: 'enable_credits_consumption_in_ui',
  ENABLE_ASTRAL_V2_IN_UI: 'enable_astral_v2_in_ui',
  ENABLE_QUILL_SSE_STREAMING: 'quill_sse_streaming',
  ENABLE_INTERNAL_AUTOMATION_PORTABILITY:
    'enable_internal_automation_portability',
  ENABLE_FINANCE_WORKSPACE: 'enable_finance_workspace',
  ENABLE_NEW_WORKBENCH: 'enable_new_workbench',
  ENABLE_AGENT_BUILDER: 'enable_agent_builder',
  ENABLE_CARTOGRAPHER: 'enable_cartographer',
  // Apps tab: prebuilt apps that run on mock data until their blueprints are built.
  ENABLE_AGENT_APPS: 'enable_agent_apps',
  // New agents open on the build canvas, which needs Smith v30's canvas tools.
  ENABLE_AGENT_CANVAS: 'enable_agent_canvas',
  AOP_MAP: 'aop_map',
  // Automations and agents catalogs on the shared asset catalog layout.
  CONSISTENT_LAYOUT: 'Consistent_Layout',
  // Connections to integrations that support remote secrets reference a
  // managed (Gringotts) credential instead of carrying values inline.
  ENABLE_GRINGOTTS: 'enable_gringotts',
} as const;
